import {fromStringToMoment, isFutureFromToday} from "../../components/FiltersDateTimeSelector/utils";

export const getEndtimeIfNotInFuture = function(endtime?: string): string | undefined {
    if(!endtime) return
    let _endtimeMoment = fromStringToMoment(endtime)
    if(_endtimeMoment)
        if(_endtimeMoment.isValid())
            if(!isFutureFromToday(_endtimeMoment))
                return endtime
}